import { FilterConfigPassive } from '@/types/filter';
import { Dayjs } from 'dayjs';
import getSingleDateFilterOptions from '../../utils/getSingleDateFilterOptions';

const singleDateFilter: FilterConfigPassive<Dayjs> = {
  label: 'global.filters.formControls.dateRangeLabel',
  options: getSingleDateFilterOptions(),
  defaultValue: new Date(),
  type: 'dropdown',
};

export default singleDateFilter;
